import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ResponsiveImage from './ResponsiveImage';

export default function AppStoreBadges() {
  const { t } = useTranslation();
  const [showAndroidPopup, setShowAndroidPopup] = useState(false);

  useEffect(() => {
    if (showAndroidPopup) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      if (scrollbarWidth > 0) {
        document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
        const header = document.querySelector('header');
        if (header) header.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      const header = document.querySelector('header');
      if (header) header.style.paddingRight = '';
    }
    return () => {
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';
      const header = document.querySelector('header');
      if (header) header.style.paddingRight = '';
    };
  }, [showAndroidPopup]);

  return (
    <>
      <div className="flex flex-row gap-2 items-center justify-center">
        <a
          href="https://apps.apple.com/us/app/tripreel-travel-route-videos/id6757102726"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-block hover:scale-105 transition-transform duration-200"
        >
          <img 
            src="/app-store-badge.svg" 
            alt="Download on the App Store" 
            style={{ height: '44.8px', width: 'auto' }}
          />
        </a>
        
        <button
          onClick={() => {
            setShowAndroidPopup(true);

          }}
          className="group relative inline-block hover:scale-105 transition-transform duration-200 cursor-pointer"
          style={{ width: '154px', height: '44.8px' }}
        >
          <ResponsiveImage 
            src="/google-play-badge.png" 
            alt="Get it on Google Play" 
            width={154}
            height={45}
            style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scale(1.09)' }}
          />
          <div className="absolute -top-3 -right-3 bg-slate-600/90 dark:bg-slate-700/90 text-white text-xs font-semibold px-1.5 py-0.5 rounded-full shadow-lg border border-slate-300 dark:border-slate-600 backdrop-blur-sm">
            {t('appStore.comingSoon')}
          </div>
        </button>
      </div>

      {/* Android Coming Soon Popup */}
      {showAndroidPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={() => setShowAndroidPopup(false)}>
          <div className="bg-white/60 dark:bg-slate-800/60 backdrop-blur-lg rounded-3xl shadow-2xl max-w-sm w-full p-4 border-2 border-sky-200/50 dark:border-sky-700/50" onClick={(e) => e.stopPropagation()}>
            <div className="bg-gradient-to-r from-sky-600 to-blue-600 rounded-2xl mb-4 p-4 flex items-center justify-between">
              <h3 className="text-xl font-bold text-white drop-shadow-sm">
                {t('appStore.androidTitle')}
              </h3>
              <button
                onClick={() => setShowAndroidPopup(false)}
                className="text-white hover:bg-white/20 rounded-full p-2 transition-all duration-200 hover:scale-105"
                aria-label="Close"
              >
                <X size={24} />
              </button>
            </div>
            <p className="text-slate-700 dark:text-slate-300 mb-6 text-center mt-8" dangerouslySetInnerHTML={{ __html: t('appStore.androidMessage') }}>
            </p>
            <button
              onClick={() => setShowAndroidPopup(false)}
              className="w-full bg-gradient-to-r from-sky-600 to-blue-600 hover:from-sky-700 hover:to-blue-700 text-white font-semibold py-3 px-4 rounded-2xl transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105"
            >
              {t('appStore.gotIt')}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
